export default __webpack_public_path__ + "static/media/2_fairy.9ade0ba6.png";